export default __webpack_public_path__ + "static/managedItServicesBanner-57fe01711754056e025b46b4bdde9f3c.svg";